import React from 'react';
import { HeaderPage } from '../../../components/HeaderPage/HeaderPage';
import { useParams } from 'react-router-dom';
import { CompanyInfo } from '../../../data/models/company.model';
import { useSelector } from 'react-redux';
import { selectCompany } from '../../../store/companySlide';
import { BranchCompanyTable } from '../components/DetailFormCompany/BranchCompanyTable';
import { handleTabs, TabEnum } from '../company-detail/CompanDetailNew';

const CompanyBranchLocations = () => {
  const { company_id } = useParams();
  const companyInfo: CompanyInfo = useSelector(selectCompany);

  return (
    <>
      <HeaderPage
        title={{
          title: companyInfo?.name ? companyInfo?.name : '',
          hasBack: true,
        }}
        tabs={handleTabs(
          company_id || '',
          companyInfo?.isParentCompany || false,
          TabEnum.BranchLocations,
        )}
      />

      <div className="nv-container !mt-8">
        {company_id && <BranchCompanyTable />}
      </div>
    </>
  );
};

export default CompanyBranchLocations;
